import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = { class: "p-field-radiobutton" }
const _hoisted_4 = { for: "isIconAlwaysOff" }
const _hoisted_5 = { class: "p-field-radiobutton" }
const _hoisted_6 = { for: "isIconAlwaysOff" }
const _hoisted_7 = { class: "mt-4 mb-2" }
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = { class: "mb-0 ml-3" }
const _hoisted_10 = { class: "mt-4" }
const _hoisted_11 = { class: "px-3" }
const _hoisted_12 = { class: "d-flex justify-content-end mt-3 px-2" }
const _hoisted_13 = { class: "mt-4 mb-2" }
const _hoisted_14 = { class: "mt-4" }
const _hoisted_15 = { class: "px-3" }
const _hoisted_16 = { class: "d-flex justify-content-end mt-3 px-2" }
const _hoisted_17 = { class: "mr-2" }
const _hoisted_18 = { class: "px-3" }
const _hoisted_19 = { class: "d-flex justify-content-end mt-3 px-2" }
const _hoisted_20 = { class: "px-3" }
const _hoisted_21 = { class: "d-flex justify-content-end mt-3 px-2" }
const _hoisted_22 = { class: "mt-4 mb-2" }
const _hoisted_23 = { class: "mt-4" }
const _hoisted_24 = { class: "px-3" }
const _hoisted_25 = { class: "d-flex justify-content-end mt-3 px-2" }
const _hoisted_26 = { class: "mr-2" }
const _hoisted_27 = { class: "px-3" }
const _hoisted_28 = { class: "d-flex justify-content-end mt-3 px-2" }
const _hoisted_29 = { class: "px-3" }
const _hoisted_30 = { class: "d-flex justify-content-end mt-3 px-2" }
const _hoisted_31 = { class: "mt-4 mb-2" }
const _hoisted_32 = { class: "mt-4" }
const _hoisted_33 = { class: "px-3" }
const _hoisted_34 = { class: "d-flex justify-content-end mt-3 px-2" }
const _hoisted_35 = { class: "mr-2" }
const _hoisted_36 = { class: "px-3" }
const _hoisted_37 = { class: "d-flex justify-content-end mt-3 px-2" }
const _hoisted_38 = { class: "px-3" }
const _hoisted_39 = { class: "d-flex justify-content-end mt-3 px-2" }
const _hoisted_40 = { class: "mt-4 mb-2" }
const _hoisted_41 = { class: "mt-4" }
const _hoisted_42 = { class: "px-3" }
const _hoisted_43 = { class: "d-flex justify-content-end mt-3 px-2" }
const _hoisted_44 = { class: "mr-2" }
const _hoisted_45 = { class: "px-3" }
const _hoisted_46 = { class: "d-flex justify-content-end mt-3 px-2" }
const _hoisted_47 = { class: "px-3" }
const _hoisted_48 = { class: "d-flex justify-content-end mt-3 px-2" }
const _hoisted_49 = { class: "p-field-checkbox d-flex align-items-center mt-3" }
const _hoisted_50 = { for: "ApplyAllThermostats" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioButton = _resolveComponent("RadioButton")
  const _component_InputSwitch = _resolveComponent("InputSwitch")
  const _component_Slider = _resolveComponent("Slider")
  const _component_Divider = _resolveComponent("Divider")
  const _component_SelectButton = _resolveComponent("SelectButton")
  const _component_Checkbox = _resolveComponent("Checkbox")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.preferenceLabel)
      ? (_openBlock(), _createBlock("h1", _hoisted_1, _toDisplayString(_ctx.preferenceLabel), 1))
      : _createCommentVNode("", true),
    _createVNode("h5", _hoisted_2, _toDisplayString(_ctx.$t("AppResource.IconsUpper")), 1),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_RadioButton, {
        id: "isIconAlwaysOff",
        name: "isIconAlwaysOff",
        value: true,
        modelValue: _ctx.roomObject.isIconAlwaysOff,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.roomObject.isIconAlwaysOff = $event)),
        disabled: _ctx.readOnly
      }, null, 8, ["modelValue", "disabled"]),
      _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("AppResource.AlwaysOff")), 1)
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_RadioButton, {
        id: "isIconAlwaysOff",
        name: "isIconAlwaysOff",
        value: false,
        modelValue: _ctx.roomObject.isIconAlwaysOff,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.roomObject.isIconAlwaysOff = $event)),
        disabled: _ctx.readOnly
      }, null, 8, ["modelValue", "disabled"]),
      _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("AppResource.OffWhenClosed")), 1)
    ]),
    _createVNode("h5", _hoisted_7, _toDisplayString(_ctx.$t("AppResource.ContactNoUpper")), 1),
    _createVNode("div", _hoisted_8, [
      _createVNode(_component_InputSwitch, {
        modelValue: _ctx.roomObject.isLocalContactNumberEnabled,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.roomObject.isLocalContactNumberEnabled = $event)),
        disabled: _ctx.readOnly
      }, null, 8, ["modelValue", "disabled"]),
      _createVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("AppResource.EnableContactNumber")), 1)
    ]),
    _createVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("AppResource.NumberOfContact")), 1),
    _createVNode("div", _hoisted_11, [
      _createVNode(_component_Slider, {
        disabled: !_ctx.roomObject.isLocalContactNumberEnabled || _ctx.readOnly,
        modelValue: _ctx.roomObject.numberOfWindowsContact,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.roomObject.numberOfWindowsContact = $event)),
        min: 0,
        max: 201,
        step: 1
      }, null, 8, ["disabled", "modelValue"])
    ]),
    _createVNode("div", _hoisted_12, [
      _createVNode("span", null, _toDisplayString(_ctx.roomObject.numberOfWindowsContact), 1)
    ]),
    _createVNode(_component_Divider),
    _createVNode("h5", _hoisted_13, _toDisplayString(_ctx.$t("AppResource.OpeningHeatingContactUpper")), 1),
    _createVNode(_component_SelectButton, {
      modelValue: _ctx.roomObject.openingContactTypeHeating,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.roomObject.openingContactTypeHeating = $event)),
      options: _ctx.contactTypeOptions,
      dataKey: "value",
      optionLabel: "label",
      optionValue: "value",
      disabled: _ctx.readOnly
    }, null, 8, ["modelValue", "options", "disabled"]),
    _createVNode("p", _hoisted_14, _toDisplayString(_ctx.$t("AppResource.SetTemperature")), 1),
    _createVNode("div", _hoisted_15, [
      _createVNode(_component_Slider, {
        modelValue: _ctx.roomObject.openingContactTempHeating,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.roomObject.openingContactTempHeating = $event)),
        min: _ctx.chosenTempParams.min,
        max: _ctx.chosenTempParams.max,
        step: _ctx.chosenTempParams.step,
        disabled: _ctx.readOnly
      }, null, 8, ["modelValue", "min", "max", "step", "disabled"])
    ]),
    _createVNode("div", _hoisted_16, [
      _createVNode("span", _hoisted_17, _toDisplayString(_ctx.tempLabel) + ": ", 1),
      _createVNode("span", null, _toDisplayString(_ctx.roomObject.openingContactTempHeating), 1)
    ]),
    _createVNode("p", null, _toDisplayString(_ctx.$t("AppResource.OpeningContactDelayHeating")), 1),
    _createVNode("div", _hoisted_18, [
      _createVNode(_component_Slider, {
        modelValue: _ctx.openingContactDelayHeating,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.openingContactDelayHeating = $event)),
        min: 0,
        max: 1275,
        step: 5,
        disabled: _ctx.readOnly
      }, null, 8, ["modelValue", "disabled"])
    ]),
    _createVNode("div", _hoisted_19, [
      _createVNode("span", null, _toDisplayString(_ctx.roomObject.openingContactDelayHeating), 1)
    ]),
    _createVNode("p", null, _toDisplayString(_ctx.$t("AppResource.TimeoutLocalContactOpening")), 1),
    _createVNode("div", _hoisted_20, [
      _createVNode(_component_Slider, {
        modelValue: _ctx.timeoutOpeningHeating,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.timeoutOpeningHeating = $event)),
        min: 0,
        max: 1275,
        step: 5,
        disabled: _ctx.readOnly
      }, null, 8, ["modelValue", "disabled"])
    ]),
    _createVNode("div", _hoisted_21, [
      _createVNode("span", null, _toDisplayString(_ctx.roomObject.timeoutOpeningHeating), 1)
    ]),
    _createVNode(_component_Divider),
    _createVNode("h5", _hoisted_22, _toDisplayString(_ctx.$t("AppResource.ClosingHeatingContactUpper")), 1),
    _createVNode(_component_SelectButton, {
      modelValue: _ctx.roomObject.closingContactTypeHeating,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.roomObject.closingContactTypeHeating = $event)),
      options: _ctx.contactTypeOptions,
      dataKey: "value",
      optionLabel: "label",
      optionValue: "value",
      disabled: _ctx.readOnly
    }, null, 8, ["modelValue", "options", "disabled"]),
    _createVNode("p", _hoisted_23, _toDisplayString(_ctx.$t("AppResource.SetTemperature")), 1),
    _createVNode("div", _hoisted_24, [
      _createVNode(_component_Slider, {
        modelValue: _ctx.roomObject.closingContactTempHeating,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.roomObject.closingContactTempHeating = $event)),
        min: _ctx.chosenTempParams.min,
        max: _ctx.chosenTempParams.max,
        step: _ctx.chosenTempParams.step,
        disabled: _ctx.readOnly
      }, null, 8, ["modelValue", "min", "max", "step", "disabled"])
    ]),
    _createVNode("div", _hoisted_25, [
      _createVNode("span", _hoisted_26, _toDisplayString(_ctx.tempLabel) + ": ", 1),
      _createVNode("span", null, _toDisplayString(_ctx.roomObject.closingContactTempHeating), 1)
    ]),
    _createVNode("p", null, _toDisplayString(_ctx.$t("AppResource.ClosingContactDelayHeating")), 1),
    _createVNode("div", _hoisted_27, [
      _createVNode(_component_Slider, {
        modelValue: _ctx.closingContactDelayHeating,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.closingContactDelayHeating = $event)),
        min: 0,
        max: 1275,
        step: 5,
        disabled: _ctx.readOnly
      }, null, 8, ["modelValue", "disabled"])
    ]),
    _createVNode("div", _hoisted_28, [
      _createVNode("span", null, _toDisplayString(_ctx.roomObject.closingContactDelayHeating), 1)
    ]),
    _createVNode("p", null, _toDisplayString(_ctx.$t("AppResource.TimeoutLocalContactClosing")), 1),
    _createVNode("div", _hoisted_29, [
      _createVNode(_component_Slider, {
        modelValue: _ctx.timeoutClosingHeating,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.timeoutClosingHeating = $event)),
        min: 0,
        max: 1275,
        step: 5,
        disabled: _ctx.readOnly
      }, null, 8, ["modelValue", "disabled"])
    ]),
    _createVNode("div", _hoisted_30, [
      _createVNode("span", null, _toDisplayString(_ctx.roomObject.timeoutClosingHeating), 1)
    ]),
    _createVNode(_component_Divider),
    _createVNode("h5", _hoisted_31, _toDisplayString(_ctx.$t("AppResource.OpeningCoolingContactUpper")), 1),
    _createVNode(_component_SelectButton, {
      modelValue: _ctx.roomObject.openingContactTypeCooling,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.roomObject.openingContactTypeCooling = $event)),
      options: _ctx.contactTypeOptions,
      dataKey: "value",
      optionLabel: "label",
      optionValue: "value",
      disabled: _ctx.readOnly
    }, null, 8, ["modelValue", "options", "disabled"]),
    _createVNode("p", _hoisted_32, _toDisplayString(_ctx.$t("AppResource.SetTemperature")), 1),
    _createVNode("div", _hoisted_33, [
      _createVNode(_component_Slider, {
        modelValue: _ctx.roomObject.openingContactTempCooling,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.roomObject.openingContactTempCooling = $event)),
        min: _ctx.chosenTempParams.min,
        max: _ctx.chosenTempParams.max,
        step: _ctx.chosenTempParams.step,
        disabled: _ctx.readOnly
      }, null, 8, ["modelValue", "min", "max", "step", "disabled"])
    ]),
    _createVNode("div", _hoisted_34, [
      _createVNode("span", _hoisted_35, _toDisplayString(_ctx.tempLabel) + ": ", 1),
      _createVNode("span", null, _toDisplayString(_ctx.roomObject.openingContactTempCooling), 1)
    ]),
    _createVNode("p", null, _toDisplayString(_ctx.$t("AppResource.OpeningContactDelayCooling")), 1),
    _createVNode("div", _hoisted_36, [
      _createVNode(_component_Slider, {
        modelValue: _ctx.openingContactDelayCooling,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.openingContactDelayCooling = $event)),
        min: 0,
        max: 1275,
        step: 5,
        disabled: _ctx.readOnly
      }, null, 8, ["modelValue", "disabled"])
    ]),
    _createVNode("div", _hoisted_37, [
      _createVNode("span", null, _toDisplayString(_ctx.roomObject.openingContactDelayCooling), 1)
    ]),
    _createVNode("p", null, _toDisplayString(_ctx.$t("AppResource.TimeoutLocalContactOpening")), 1),
    _createVNode("div", _hoisted_38, [
      _createVNode(_component_Slider, {
        modelValue: _ctx.timeoutOpeningCooling,
        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.timeoutOpeningCooling = $event)),
        min: 0,
        max: 1275,
        step: 5,
        disabled: _ctx.readOnly
      }, null, 8, ["modelValue", "disabled"])
    ]),
    _createVNode("div", _hoisted_39, [
      _createVNode("span", null, _toDisplayString(_ctx.roomObject.timeoutOpeningCooling), 1)
    ]),
    _createVNode(_component_Divider),
    _createVNode("h5", _hoisted_40, _toDisplayString(_ctx.$t("AppResource.ClosingCoolingContactUpper")), 1),
    _createVNode(_component_SelectButton, {
      modelValue: _ctx.roomObject.closingContactTypeCooling,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.roomObject.closingContactTypeCooling = $event)),
      options: _ctx.contactTypeOptions,
      dataKey: "value",
      optionLabel: "label",
      optionValue: "value",
      disabled: _ctx.readOnly
    }, null, 8, ["modelValue", "options", "disabled"]),
    _createVNode("p", _hoisted_41, _toDisplayString(_ctx.$t("AppResource.SetTemperature")), 1),
    _createVNode("div", _hoisted_42, [
      _createVNode(_component_Slider, {
        modelValue: _ctx.roomObject.closingContactTempCooling,
        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.roomObject.closingContactTempCooling = $event)),
        min: _ctx.chosenTempParams.min,
        max: _ctx.chosenTempParams.max,
        step: _ctx.chosenTempParams.step,
        disabled: _ctx.readOnly
      }, null, 8, ["modelValue", "min", "max", "step", "disabled"])
    ]),
    _createVNode("div", _hoisted_43, [
      _createVNode("span", _hoisted_44, _toDisplayString(_ctx.tempLabel) + ": ", 1),
      _createVNode("span", null, _toDisplayString(_ctx.roomObject.closingContactTempCooling), 1)
    ]),
    _createVNode("p", null, _toDisplayString(_ctx.$t("AppResource.ClosingContactDelayCooling")), 1),
    _createVNode("div", _hoisted_45, [
      _createVNode(_component_Slider, {
        modelValue: _ctx.closingContactDelayCooling,
        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.closingContactDelayCooling = $event)),
        min: 0,
        max: 1275,
        step: 5,
        disabled: _ctx.readOnly
      }, null, 8, ["modelValue", "disabled"])
    ]),
    _createVNode("div", _hoisted_46, [
      _createVNode("span", null, _toDisplayString(_ctx.roomObject.closingContactDelayCooling), 1)
    ]),
    _createVNode("p", null, _toDisplayString(_ctx.$t("AppResource.TimeoutLocalContactClosing")), 1),
    _createVNode("div", _hoisted_47, [
      _createVNode(_component_Slider, {
        modelValue: _ctx.timeoutClosingCooling,
        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.timeoutClosingCooling = $event)),
        min: 0,
        max: 1275,
        step: 5,
        disabled: _ctx.readOnly
      }, null, 8, ["modelValue", "disabled"])
    ]),
    _createVNode("div", _hoisted_48, [
      _createVNode("span", null, _toDisplayString(_ctx.roomObject.timeoutClosingCooling), 1)
    ]),
    _createVNode("div", _hoisted_49, [
      _createVNode(_component_Checkbox, {
        id: "ApplyAllThermostats",
        name: "ApplyAllThermostats",
        modelValue: _ctx.roomObject.isApplyAllWindowsContact,
        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.roomObject.isApplyAllWindowsContact = $event)),
        binary: true,
        disabled: _ctx.readOnly
      }, null, 8, ["modelValue", "disabled"]),
      _createVNode("label", _hoisted_50, _toDisplayString(_ctx.$t("AppResource.ApplyAllThermostats")), 1)
    ])
  ]))
}